import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Sends GA4 page_view on every route change.
 * Consent is enforced via Consent Mode (configured in public/index.html).
 */
export default function useGaPageViews(measurementId = (window.__GA_MEASUREMENT_ID__ || "")) {
  const location = useLocation();

  useEffect(() => {
    if (!window.gtag || !measurementId) return;
    // Micro-debounce so rapid transitions don't double-fire
    const t = setTimeout(() => {
      window.gtag("config", measurementId, {
        page_path: location.pathname + (location.search || ""),
        page_location: window.location.href,
        page_title: document.title,
      });
    }, 0);
    return () => clearTimeout(t);
  }, [location.pathname, location.search, measurementId]);
}


